import { render, staticRenderFns } from "./ProductMeta.vue?vue&type=template&id=22b12150&scoped=true&"
import script from "./ProductMeta.vue?vue&type=script&lang=js&"
export * from "./ProductMeta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b12150",
  null
  
)

export default component.exports